import { BlobServiceClient} from '@azure/storage-blob';
import { useConfigs } from "../../../configuration/useConfigs";

// disable storage feature to app if not configured
export const isStorageConfigured = (AZURE_STORAGE_ACCOUNT_NAME, AZURE_STORAGE_SAS_TOKEN) => {
  return !((!AZURE_STORAGE_ACCOUNT_NAME || !AZURE_STORAGE_SAS_TOKEN));
};

// return list of blobs in container to display
const getBlobsInContainer = async (containerClient,AZURE_STORAGE_ACCOUNT_NAME, AZURE_STORAGE_CONTAINER) => {
  const returnedBlobUrls = [];

  // get list of blobs in container
  // eslint-disable-next-line
  for await (const blob of containerClient.listBlobsFlat()) {
    // if image is public, just construct URL
    returnedBlobUrls.push(
      `https://${AZURE_STORAGE_ACCOUNT_NAME}.blob.core.windows.net/${AZURE_STORAGE_CONTAINER}/${blob.name}`
    );
  }

  return returnedBlobUrls;
};

const createBlobInContainer = async (containerClient, folder, file) => {  
  // create blobClient for container
  const blobClient = containerClient.getBlockBlobClient(folder + file.name);

  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  // upload file
  await blobClient.uploadBrowserData(file, options);
};

const uploadFileToBlob = async (folder, file, AZURE_STORAGE_ACCOUNT_NAME, AZURE_STORAGE_SAS_TOKEN, AZURE_STORAGE_CONTAINER) => {
  
  if (!file) return [];

  // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
  const blobService = new BlobServiceClient(
    `https://${AZURE_STORAGE_ACCOUNT_NAME}.blob.core.windows.net/?${AZURE_STORAGE_SAS_TOKEN}`
  );
  // get Container - full public read access
  const containerClient = blobService.getContainerClient(AZURE_STORAGE_CONTAINER);

  // upload file
  await createBlobInContainer(containerClient, folder, file);

 return;
};

export default uploadFileToBlob;